<script lang="ts" setup>
import Adv1 from '~/assets/gitex/gitex-advantages1.svg';
import Adv2 from '~/assets/gitex/gitex-advantages2.svg';
import Adv3 from '~/assets/gitex/gitex-advantages3.svg';
import Adv4 from '~/assets/gitex/gitex-advantages4.svg';
import {useRuntimeConfig} from '#imports';
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
</script>

<template>
  <div class="gitex-advantages">
    <div class="gitex-advantages__info">
      <div class="gitex-advantages__info-card">
        <Adv1 class="gitex-advantages__info-icon" />
        <div class="gitex-advantages__info-desc">
          <div class="gitex-advantages__info-title">
            {{ $t('easy') }}
          </div>
          <div class="gitex-advantages__info-text">
            {{ $t('dfEasyInterface') }}
          </div>
        </div>
      </div>
      <div class="gitex-advantages__info-card">
        <Adv2 class="gitex-advantages__info-icon" />
        <div class="gitex-advantages__info-desc">
          <div class="gitex-advantages__info-title">
            {{ $t('fastAndConv') }}
          </div>
          <div class="gitex-advantages__info-text">
            {{ $t('anyoneCanCreate') }}
          </div>
        </div>
      </div>
      <div class="gitex-advantages__info-card">
        <Adv3 class="gitex-advantages__info-icon" />
        <div class="gitex-advantages__info-desc">
          <div class="gitex-advantages__info-title">
            {{ $t('bigChoice') }}
          </div>
          <div class="gitex-advantages__info-text">
            {{ $t('extensiveRangeTools') }}
          </div>
        </div>
      </div>
      <div class="gitex-advantages__info-card">
        <Adv4 class="gitex-advantages__info-icon" />
        <div class="gitex-advantages__info-desc">
          <div class="gitex-advantages__info-title">
            {{ $t('powerfulEngine') }}
          </div>
          <div class="gitex-advantages__info-text">
            {{ $t('projHaveUeGraph') }}
          </div>
        </div>
      </div>
    </div>
    <video
      class="gitex-advantages__video"
      no-controls
      autoplay
      loop
      playsinline
      muted
      style=""
    >
      <source
        :src="`${staticUrl}/video/advantages.mp4`"
        type="video/mp4"
      />
    </video>
  </div>
</template>

<style scoped lang="scss">
.gitex-advantages {
  display: flex;
  gap: 24px;

  &__video {
    width: 100%;
    height: auto;
    border-radius: 16px;
    display: block;
    max-width: 552px;
  }

  &__info {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px 24px;

    &-card {
      display: flex;
      gap: 16px;

      svg {
        width: 48px;
        height: 48px;
        display: block;
        min-width: 48px;
        outline: none;
      }
    }

    &-desc {
      padding-top: 14px;
    }

    &-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: #3d424a;
    }

    &-text {
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: #64686e;
      margin-top: 8px;
    }
  }

  @media (max-width: $lg) {
    flex-direction: column;
    &__video {
      width: 100%;
      height: initial;
    }

    &__info {
      display: flex;
      flex-direction: column;
      gap: 16px;

      &-title {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: 0.02em;
      }

      &-text {
        font-size: 15px;
        line-height: 140%;
        letter-spacing: 0.03em;
      }
    }
  }
}
</style>
